import { ComponentNode, type Types } from "@a2ui/react";

/**
 * Defensively extract a plain string from a value that may be either a raw
 * string or a wrapped StringValue `{ literalString: "..." }`. Useful for
 * enum / scalar properties that should be plain strings according to the
 * A2UI schema but might arrive wrapped if the builder incorrectly uses sv().
 */
export function resolveEnum<T extends string>(
  value: unknown,
  fallback: T,
): T {
  if (typeof value === "string") return value as T;
  if (
    typeof value === "object" &&
    value !== null &&
    "literalString" in value
  ) {
    return (value as { literalString: string }).literalString as T;
  }
  return fallback;
}

export function renderChildren(children: unknown[], surfaceId: string) {
  return children.map((child, index) => {
    const childId =
      typeof child === "object" && child !== null && "id" in child
        ? (child as { id: string }).id
        : `child-${index}`;
    const childNode =
      typeof child === "object" && child !== null && "type" in child
        ? (child as Types.AnyComponentNode)
        : null;
    return (
      <ComponentNode key={childId} node={childNode} surfaceId={surfaceId} />
    );
  });
}
